<script>
export default {
  name: 'word-variations',
  methods: {
    personWordVariations (value) {
      if (value === 1) {
        return window.bookero.translations.$t('common.ui.variations.person.single');
      }

      if (
        (value >= 2 && value <= 4) ||
        (value > 20 && value % 10 >= 2 && value % 10 <= 4)
      ) {
        return window.bookero.translations.$t('common.ui.variations.person.plural1');
      }

      return window.bookero.translations.$t('common.ui.variations.person.plural2');
    },
    reservationWordVariations (value) {
      if (value === 1) {
        return window.bookero.translations.$t('common.ui.variations.reservation.single');
      }

      if (
        (value >= 2 && value <= 4) ||
        (value > 20 && value % 10 >= 2 && value % 10 <= 4)
      ) {
        return window.bookero.translations.$t('common.ui.variations.reservation.plural1');
      }

      return window.bookero.translations.$t('common.ui.variations.reservation.plural2');
    },
    blockedDateWordVariations (value) {
      if (value === 1) {
        return window.bookero.translations.$t('common.ui.variations.blockedDate.single');
      }

      if (
        (value >= 2 && value <= 4) ||
        (value > 20 && value % 10 >= 2 && value % 10 <= 4)
      ) {
        return window.bookero.translations.$t('common.ui.variations.blockedDate.plural1');
      }

      return window.bookero.translations.$t('common.ui.variations.blockedDate.plural2');
    },
    ongoingReservationsWordVariations (value) {
      if (value === 1) {
        return window.bookero.translations.$t('common.ui.variations.currentReservation.single');
      }

      if (
        (value >= 2 && value <= 4) ||
        (value > 20 && value % 10 >= 2 && value % 10 <= 4)
      ) {
        return window.bookero.translations.$t('common.ui.variations.currentReservation.plural1');
      }

      return window.bookero.translations.$t('common.ui.variations.currentReservation.plural2');
    },
    ongoingBlockedDatesWordVariations (value) {
      if (value === 1) {
        return window.bookero.translations.$t('common.ui.variations.currentBlockedDate.single');
      }

      if (
        (value >= 2 && value <= 4) ||
        (value > 20 && value % 10 >= 2 && value % 10 <= 4)
      ) {
        return window.bookero.translations.$t('common.ui.variations.currentBlockedDate.plural1');
      }

      return window.bookero.translations.$t('common.ui.variations.currentBlockedDate.plural2');
    },
    pastReservationsWordVariations (value) {
      if (value === 1) {
        return window.bookero.translations.$t('common.ui.variations.pastReservation.single');
      }

      if (
        (value >= 2 && value <= 4) ||
        (value > 20 && value % 10 >= 2 && value % 10 <= 4)
      ) {
        return window.bookero.translations.$t('common.ui.variations.pastReservation.plural1');
      }

      return window.bookero.translations.$t('common.ui.variations.pastReservation.plural2');
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/mixins/WordVariations.vue